// extracted by mini-css-extract-plugin
export default {"buttons":"ratearticle_buttons__UVfb9","reason":"ratearticle_reason__jgHSi","information":"ratearticle_information__ipJMy"};